import { Component, forwardRef } from '@angular/core';
import { WlmColumnComponent } from '@common-modules/wlm-grid/wlm-column/wlm-column.component';
import { ColumnBase } from '@progress/kendo-angular-grid';

@Component({
  selector: 'wlm-attribute-column',
  templateUrl: './attribute-column.component.html',
  styleUrl: './attribute-column.component.scss',
  providers: [
    {
      provide: ColumnBase,
      useExisting: forwardRef(() => AttributeColumnComponent),
    },
  ],
  standalone: false
})



export class AttributeColumnComponent extends WlmColumnComponent {
  formatField: string;
  unitField: string;

  ngOnInit(): void {
    this.formatField = `${this.field}_format`;
    this.unitField = `${this.field}_units`;
  }

  getValue(data): string {
    const value = data[this.field] as string;
    return this.elements?.get(value === undefined || value === null ? null : value)?.toString();
  }
}
